import React from 'react';
import ColButton from '../../../Elements/ColButton';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FaIcon from '../../../Elements/FaIcon';
import LoadingIcon from '../../../Elements/LoadingIcon';
import PanelBorder from '../../../Elements/PanelBorder';
import ReportTemplateService from '../../../Services/ReportTemplateService';
import UploadTemplateParameters from './UploadTemplateParameters';

class UploadTemplateFilePanel extends React.Component {
  static defaultProps = {
    //reportItem: new ReportTemplateItem(),
    clickOnCancel: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      reportItem: new UploadTemplateParameters(props.reportItem.ReportTemplateId),
      loading: false,
    };
    this.fileUploadOnChange = this.fileUploadOnChange.bind(this);
  }

  componentDidMount() {}

  onSubmit() {
    const data = new FormData();
    data.append('file', this.state.reportItem.selectedFile);
    data.append('ReportTemplateId', this.state.reportItem.ReportTemplateId);
    this.setState({ loading: true });
    ReportTemplateService.postUploadReportTemplateFile(data)
      .then((result) => {
        this.props.clickOnOk();
      })
      .catch((error) => ErrorMessage.SetErrorMessage('UTFP4'));
  }

  fileUploadOnChange(e) {
    if (e.target.files.length > 0) {
      this.setState({
        reportItem: {
          ...this.state.reportItem,
          selectedFile: e.target.files[0],
        },
      });
    } else {
      this.setState({
        reportItem: {
          ...this.state.reportItem,
          selectedFile: null,
        },
      });
    }
  }

  renderFileUploadField() {
    let errorMessage = this.state.reportItem.selectedFile ? '' : 'You have to select a file!';
    return (
      <div
        className={
          'col-11 text-center hover rounded m-2' + (errorMessage ? ' border rounded border-danger bg-warning' : '')
        }
      >
        <label htmlFor='fileupload'>Choose an XLS or XLSX file</label>
        <div className='input-group'>
          <div className='custom-file d-flex justify-content-center'>
            <FaIcon
              iconName='fa-solid fa-file-excel'
              className='h1 text-primary p-1'
            />
            <input
              className=''
              type='file'
              onChange={this.fileUploadOnChange}
              id='fileupload'
              accept='.xls, .xlsx'
            />
          </div>
        </div>
        {errorMessage !== '' ? <div className='text-danger text-center p-1'>{errorMessage}</div> : null}
      </div>
    );
  }

  AllRulesAreFullfilled() {
    return this.state.reportItem.selectedFile !== null && !this.state.loading;
  }

  render() {
    return (
      <PanelBorder
        headerText='Upload File for an Existing Report Template'
        clickOnCancel={this.props.clickOnCancel}
        icon='fa-solid fa-plus-circle'
        minWidth='800px'
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.onSubmit();
          }}
        >
          <div className=''>
            <div className='h4'>ReportTemplate: {this.props.reportItem.Name}</div>

            <div className='row justify-content-center'>{this.renderFileUploadField()}</div>

            <LoadingIcon loading={this.state.loading} />

            <div className='buttonfooter'>
              <div className='container-fluid'>
                <div className='row'>
                  <ColButton
                    text='Cancel'
                    onClick={this.props.clickOnCancel}
                  />
                  <ColButton
                    text='Upload File'
                    type='submit'
                    icon={'fa-solid fa-upload' + (this.state.loading ? ' fa-spin' : '')}
                    disabled={!this.AllRulesAreFullfilled()}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </PanelBorder>
    );
  }
}

export default UploadTemplateFilePanel;
